<template>
  <div class="page">
    <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="page-location">
      <div class="w1200">
        <ul class="pagenav">
          <li>
            <a href="javascript:;" @click="$router.push({name: 'personnel'})">{{ $t('personnelnav')}}</a>
          </li>
          <li class="s">
            <a href="javascript:;" @click="$router.push({name: 'recruit'})">{{ $t('recruit')}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="page-main">
      <div class="w1200">
        <div class="joinusbg">
          <div class="left">
            {{ $t('contactte')}}
          </div>
          <div class="right">
            <span>{{ $t('dianhua')}} ：{{job_mobile}}</span>
            <span>{{ $t('email')}}：{{email}}</span>
          </div>
        </div>
        <ul class="joinlist">
          <li v-for="(data, index) in datas" :key="index" @click="showwrapfun(data)">
            <div class="top">
              <div class="title">{{data.title}}</div>
              <div class="gongzi">{{data.wages}}</div>
            </div>
            <span class="sp1">{{ $t('didian')}}：{{data.place}} 丨 {{ $t('zprs')}}{{data.people}} 丨 {{ $t('xueli')}}：{{data.education}}</span>
            <span class="sp2">{{ $t('fbrq')}}：{{data.create_time}}</span>
            <a href="javascript:;"></a>
          </li>
        </ul>
        <div class="newslist-pageindex">
          <a href="javascript:;" @click="page(1)">{{ $t('first')}}</a>
          <a href="javascript:;" @click="page(cur-1)">{{ $t('prev')}}</a>
          <a href="javascript:;" v-if="cur > 2 && all!=2">...</a>
          <a href="javascript:;" v-for="index in pageindexarr" :key="index" @click="page(index)" :class="{active:cur===index}">{{index}}</a>
          <a href="javascript:;" v-if="all > cur && all > 2">...</a>
          <a href="javascript:;" @click="page(cur+1)">{{ $t('next')}}</a>
          <span>{{ $t('all')}}{{alllength}}{{ $t('tiao')}} {{ $t('gong')}}{{all}}{{ $t('ye')}}</span>
        </div>
      </div>
    </div>
    <div class="joinuswarpbg" v-if="wrapshow">
      <div class="joinuswrap">
        <div class="joinuswrap-top">
          <div class="left">
            <h1>{{wrapdata.title}}</h1>
            <span>{{ $t('didian')}}：{{ wrapdata.place}} 丨 {{ $t('zprs')}} {{wrapdata.people}} 丨 {{ $t('xueli')}}：{{wrapdata.education}}</span>
          </div>
          <div class="right">
            <a href="javascript:;" @click="closea"></a>
            <span>{{wrapdata.wages}}</span>
          </div>
        </div>
        <div class="joinuswrap-center" v-html="wrapdata.content">
        </div>
        <div class="joinuswrap-bottom">
          <a href="javascript:;" @click="gototijiao">{{ $t('sqzw')}}</a>
        </div>
      </div>
    </div>
    <div class="joinuswarpbg" v-if="tijiaoshow">
      <div class="tijiaowrap">
        <div class="tijiao-top">
          <div class="left">{{ $t('sqzw')}}</div>
          <div class="close" @click="closeb"></div>
        </div>
        <div class="download-selectbox">
          <div class="inputbox">
            <div class="box" >
              <input type="file" id="file" style="opacity: 0;" class="i2" @change="addFile" ref="inputer">
              <input type="text" class="i1" v-model="filename" @click="selectfile" :placeholder="$t('scjl')" readonly>
              <i></i>
            </div>
          </div>
        </div>
        <span class="tijiao-desc">
         {{ $t('scjldesc')}}
        </span>
        <div class="tijiao-bottom">
          <a href="javascript:;" @click="upload">{{ $t('submit')}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from '../js/ajax'
export default {
  name: 'Environment',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      datas: [],
      job_mobile: '',
      email: '',
      wrapshow: false,
      tijiaoshow: false,
      filename: '',
      file: '',
      wrapdata: {},
      all: 1,
      cur: 1,
      pageindexarr: [],
      alllength: 1
    }
  },
  mounted () {
  },
  methods: {
    page (index) {
      const that = this
      console.log(index)
      console.log(that.all)
      if (index <= 0) {
        index = 1
      }
      if (index >= this.all) {
        index = this.all
      }
      if (index === 1) {
        if (this.all < 2) {
          this.pageindexarr = [1]
        } else {
          this.pageindexarr = [1, 2]
        }
      } else if (index === 2) {
        if (this.all < 3) {
          this.pageindexarr = [1, 2]
        } else {
          this.pageindexarr = [1, 2, 3]
        }
      } else {
        if (this.all < index + 1) {
          this.pageindexarr = [index - 1, index]
        } else {
          this.pageindexarr = [index - 1, index, index + 1]
        }
      }
      if (index === this.cur) {
        return false
      }
      this.cur = index
      Fetch.post('Api/job', {
      }).then((res) => {
        that.datas = res.result.data
        that.all = res.result.last_page
        that.alllength = res.result.total
      })
    },
    showwrapfun: function (data) {
      this.wrapdata = data
      this.wrapshow = true
    },
    closea: function () {
      this.wrapshow = false
    },
    closeb: function () {
      this.tijiaoshow = false
    },
    selectfile: function () {
      // eslint-disable-next-line
      var ie = navigator.appName === 'Microsoft Internet Explorer' ? true : false 
      if (ie) {
        document.getElementById('file').click()
      } else {
        var a = document.createEvent('MouseEvents') // FF的处理
        a.initEvent('click', true, true)
        document.getElementById('file').dispatchEvent(a)
      }
    },
    addFile () {
      const that = this
      var filetypes = ['docx', 'doc', 'pdf']
      that.file = this.$refs.inputer
      let fileDom = this.$refs.inputer.files[0]
      if (filetypes.indexOf(that.getFileType(fileDom.name)) === -1) {
        that.$refs.toasttext.show(that.language[that.languagetype].err)
        return false
      }
      if (fileDom.size > 2 * 1024 * 1024) {
        that.$refs.toasttext.show(that.language[that.languagetype].size)
        return false
      }
      that.filename = fileDom.name
    },
    getFileType (name) {
      let startIndex = name.lastIndexOf('.')
      if (startIndex !== -1) {
        return name.slice(startIndex + 1).toLowerCase()
      } else {
        return ''
      }
    },
    gototijiao: function () {
      this.wrapshow = false
      this.tijiaoshow = true
    },
    upload: function () {
      const that = this
      if (this.filename === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].fileerr)
        return false
      }
      var formdata = new FormData()
      formdata.append('file', that.file.files[0])
      formdata.append('title', that.filename)
      Fetch.post('Api/resume', formdata).then((res) => {
        alert('上传成功')
        that.tijiaoshow = false
      }).catch(err => {
        that.$refs.toasttext.show(err.message)
      })
    }
  },
  created () {
    const that = this
    Fetch.post('Api/column', {
      id: 7
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/contact', {
    }).then((res) => {
      that.job_mobile = res.result.job_mobile
      that.email = res.result.email
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/job', {
    }).then((res) => {
      that.datas = res.result.data
      that.all = res.result.last_page
      that.alllength = res.result.total
      if (that.all >= 2) {
        that.pageindexarr = [1, 2]
      } else {
        that.pageindexarr = [1]
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
    padding: 0 40px;
    overflow: hidden;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner7{
    background: url(../assets/pagebanner7.png) center 0 no-repeat;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .page-location{
    height: 60px;
    background-color: #F4F4F4;
  }
  .pagenav{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content:center;
  }
  .pagenav li{
    width: 168px;
    height: 60px;
    margin: 0 3px;
  }
  .pagenav li a{
    display: block;
    width: 100%;
    height: 100%;
    line-height: 60px;
    text-align: center;
    color: #999999;
    font-size: 14px;
  }
  .pagenav .s a,.pagenav li:hover a{
    color: #E40A1F;
    font-size: 16px;
    font-weight: bold;
    background-color: #fff;
  }
  .page-content{
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0 30px;
  }
  .joinusbg{width: 100%;height: 180px;margin-top: 20px;background: url("../assets/joinusbg.png") 0 0 no-repeat;box-sizing: border-box;overflow: hidden;padding: 0 35px;display: flex;justify-content: space-between;align-items: center;}
  .joinusbg .left{font-size: 20px;font-weight: bold;height: 34px;line-height: 34px;}
  .joinusbg .right{font-size: 16px;color: #333333;display: flex;align-items: center;}
  .joinusbg .right span{padding-left: 31px;display: block;font-weight: bold;}
  .joinusbg .right span:nth-child(1) {background: url("../assets/dianhu_d.png") 0 center no-repeat;}
  .joinusbg .right span:nth-child(2) {background: url("../assets/yoxu_sa.png") 0 center no-repeat;margin-left: 52px;}
  .joinlist{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 39px;
  }
  .joinlist li{
    width: 580px;
    height: 160px;
    margin-bottom: 40px;
    box-sizing: border-box;
    padding: 0 36px;
    background-color: #F4F4F4;
    overflow: hidden;
    margin-bottom: 39px;
    cursor: pointer;
    position: relative;
  }
  .joinlist li .top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
  }
  .joinlist li .top .title{
    font-size: #333;
    font-size: 16px;
  }
  .joinlist li .top .gongzi{
    font-size:20px;
    color:#F10000;
    font-weight: bold;
  }
  .joinlist li .sp1{
    display: block;
    height: 25px;
    line-height: 25px;
    margin-top: 8px;
    font-size: 14px;
    color: #333;
  }
  .joinlist li .sp2{
    display: block;
    height: 25px;
    line-height: 25px;
    margin-top: 19px;
    font-size: 14px;
    color: #666666;
  }
  .joinlist li:hover{
    background-color: #E40A1F;
  }
  .joinlist li:hover .top .title,.joinlist li:hover .top .gongzi,.joinlist li:hover .sp1,.joinlist li:hover .sp2{
    color: #fff;
  }
  .joinlist li:hover a{
    display: block;
    position: absolute;
    left: 536px;
    top: 104px;
    width: 10px;
    height: 19px;
    background:url("../assets/jaintd_n.png") 0 0 no-repeat;
  }
  .joinuswarpbg{width: 100%;height: 100%;position: fixed;top: 0;left: 0;width: 100%;height: 100%;background-color: rgba(0,0,0,0.4);}
  .joinuswrap{width: 1200px;position: absolute;left: 50%;top: 50%; margin-left: -600px;height: 800px;background-color: #fff;box-sizing: border-box;padding: 0 50px;overflow-y: auto;transform:translateY(-50%);}
  .joinuswrap-top{
    width: 100%;
    height: 149px;
    border-bottom: 1px solid #DEDEDE;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }
  .joinuswrap-top .left{
    width: 800px;
    height: 100%;
  }
  .joinuswrap-top .left h1{
    display: block;
    width: 100%;
    height: 26px;
    margin-top: 45px;
    display: block;
    line-height: 26px;
    font-size: 16px;
    font-weight: bold;
  }
  .joinuswrap-top .left span{
    height: 24px;
    margin-top: 19px;
    line-height: 24px;
    display: block
  }
  .joinuswrap-top .right{
    height: 100%;
    width: 390px;
    text-align: right;
  }
  .joinuswrap-top .right a{
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-top: 38px;
    background:url("../assets/close.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .joinuswrap-top .right  span{
    display: block;
    width: 100%;
    margin-top: 20px;
    height: 35px;
    line-height: 35px;
    color: #F10000;
    font-size: 29px;
    font-weight: bold;
  }
  .joinuswrap-center{
    width: 100%;
    height: 560px;
    overflow-y: auto;
    box-sizing: border-box;
    padding-top: 30px;
  }
  .joinuswrap-bottom{
    width: 100%;
    height: 50px;
  }
  .joinuswrap-bottom a{
    display: flex;
    width: 120px;
    height: 50px;
    background-color: #E40A1F;
    color: #fff;
    justify-content: center;
    align-items: center;
  }
  .tijiaowrap{
    width: 1200px;position: absolute;left: 50%;top: 50%; margin-left: -600px;height: 370px;background-color: #fff;box-sizing: border-box;padding: 0 50px;overflow-y: auto;transform:translateY(-50%);
  }
  .tijiao-top{
    width: 100%;
    height: 30px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    align-content: center
  }
  .tijiao-top .left{
    font-size: 20px;
    line-height: 30px;
    color: #333;
  }
  .tijiao-top .close{
    width: 22px;
    height: 22px;
    background:url("../assets/close.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .download-selectbox{width: 100%;height: 60px;overflow: hidden;box-sizing: border-box;background-color: #fff;margin-top: 30px;}
  .download-selectbox .inputbox{width: 470px;height: 60px;display: flex;justify-content: space-between;align-items: center;background-color: #EDEDED;}
  .download-selectbox .inputbox .box{flex: 1;position: relative;display: flex;align-items: center;height: 100%;}
  .download-selectbox .inpitboxb{width: 100%;height: 0.87rem;padding: 0 0.4rem;box-sizing: border-box;}
  .download-selectbox span{line-height: 0.88rem;color: #999;font-size: 0.28rem;width: 1.2rem;flex-shrink: 0;background: #EDEDED;}
  .download-selectbox .inputbox input{flex:1;border:none;outline: none;text-align: left;line-height: 0.88rem;position: relative;z-index: 10;height: 100%;background: #EDEDED;text-indent: 20px;}
  .download-selectbox .inputbox i{display: block;width: 23px;height: 19px;background: url("../assets/shancghuan_ca.png") 0 0 no-repeat;background-size: 100% 100%;position: absolute;left: 424px;top: 21px;z-index: 10;}
  .download-selectbox div .i2{z-index: 10;position: absolute;top: 0;height: 0;width: 100%;height: 100%;text-align: right;z-index: 1;}
  .download-selectbox a{width: 100%;height: 0.88rem;line-height: 0.88rem;display: block; text-align: center;cursor: pointer;background-color: #E40A1F;color: #fff;cursor: pointer;font-size: 0.28rem;}
  .tijiao-bottom{
    width: 100%;
    height: 50px;
  }
  .tijiao-bottom a{
    display: flex;
    width: 120px;
    height: 50px;
    background-color: #E40A1F;
    color: #fff;
    justify-content: center;
    align-items: center;
  }
  .tijiao-desc{
    width: 100%;
    height: 30px;
    margin-bottom: 15px;
    display: block;
    color: #999999;
  }
  .newslist-pageindex{width: 100%;height: auto;overflow: hidden;text-align: center;margin-bottom: 15px;margin-top: 15px;}
  .newslist-pageindex a{display: inline-block;width: auto;height: 32px;background-color: #f2f2f2;color: #333333;font-size: 14px;line-height: 32px;min-width: 32px;box-sizing: border-box;padding: 0 5px; margin-left: 5px;margin-right: 5px;}
  .newslist-pageindex .active{background-color: #E40A1F;color:#fff}
  .newslist-pageindex a:hover{background-color: #E40A1F;color:#fff}
</style>



// WEBPACK FOOTER //
// src/pages/recruit.vue